import { render, staticRenderFns } from "./ModuleEditorObjects.vue?vue&type=template&id=7210e7e1"
import script from "./ModuleEditorObjects.vue?vue&type=script&lang=js"
export * from "./ModuleEditorObjects.vue?vue&type=script&lang=js"
import style0 from "./ModuleEditorObjects.vue?vue&type=style&index=0&id=7210e7e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports